import './App.css';
import {Col, Container, Image, Nav, Navbar, NavDropdown, Row} from "react-bootstrap";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import ResponsiveCenteredImageDescription from "./component/HowPokkoaWorks";
import PostPage from "./component/PostPage";
import {FaFacebookF, FaLinkedinIn, FaTelegramPlane} from "react-icons/fa";
import HowPokkoaWorks from "./component/HowPokkoaWorks";

function App() {
  return (
      <Router>
          <Container fluid className="d-flex flex-column min-vh-100 p-0">
              <Navbar bg="light" expand="md" className="shadow-sm">
                  <Container>
                      <Navbar.Brand as={Link} to="/">
                          <Image src="/logo.jpg" alt="Pokkoa Logo" height={40} rounded className="me-2" />
                          Pokkoa AI
                      </Navbar.Brand>
                      <Navbar.Toggle aria-controls="basic-navbar-nav" />
                      <Navbar.Collapse id="basic-navbar-nav">
                          <Nav className="ms-auto">
                              <NavDropdown
                                  title={<span>✨ Try Pokkoa</span>}
                                  id="try-pokkoa-hero-dropdown"
                                  align="center"
                              >
                                  <NavDropdown.Item href="https://en.pokkoa.cc">
                                      🇺🇸 English
                                  </NavDropdown.Item>
                                  <NavDropdown.Item href="https://pokkoa.cc">
                                      🇨🇳 中文
                                  </NavDropdown.Item>
                                  <NavDropdown.Item href="https://jp.pokkoa.cc">
                                      🇯🇵 日本語
                                  </NavDropdown.Item>
                              </NavDropdown>
                              <NavDropdown title="Service" id="outlook-dropdown">
                                  <NavDropdown.Item as={Link} to="/post/product/dataservice-finance">
                                      Pokkoa Emotional Intelligence Data - From Human Emotion to Financial Alpha
                                  </NavDropdown.Item>
                                  <NavDropdown.Item as={Link} to="/post/product/dataservice-finance-cn">
                                      Pokkoa 情绪智能数据平台 - 从人类情绪到金融 Alpha
                                  </NavDropdown.Item>
                                  <NavDropdown.Item as={Link} to="/post/product/dataservice">
                                      Pokkoa Emotional Intelligence Data Service
                                  </NavDropdown.Item>
                                  <NavDropdown.Item as={Link} to="/post/product/dataservice-cn">
                                      Pokkoa 情感智能数据服务
                                  </NavDropdown.Item>
                                  <NavDropdown.Item as={Link} to="/post/product/recommendation">
                                      Pokkoa Recommendation Feature Integration Guide
                                  </NavDropdown.Item>
                                  <NavDropdown.Item as={Link} to="/post/product/recommendation-cn">
                                      Pokkoa 推荐系统
                                  </NavDropdown.Item>
                              </NavDropdown>
                              <NavDropdown title="Outlook" id="outlook-dropdown">
                                  <NavDropdown.Item as={Link} to="/post/outlook/2026">
                                      2026 Overview
                                  </NavDropdown.Item>
                                  <NavDropdown.Item as={Link} to="/post/outlook/2026-all">
                                      2026 中文版详述
                                  </NavDropdown.Item>
                                  <NavDropdown.Item as={Link} to="/post/outlook/2026-all-en">
                                      2026 Detail
                                  </NavDropdown.Item>
                              </NavDropdown>
                              <NavDropdown title="Report" id="outlook-dropdown">
                                  <NavDropdown.Item as={Link} to="/post/report/data">
                                      🔮 Big Data Reveals: What Are We Really Asking?
                                  </NavDropdown.Item>
                              </NavDropdown>
                          </Nav>
                      </Navbar.Collapse>

                  </Container>
              </Navbar>

              <Routes>
                  <Route path="/" element={<ResponsiveCenteredImageDescription />} />
                  <Route path="/post/:category/:year" element={<PostPage />} />
              </Routes>

              <footer className="mt-auto">
                  <Container>
                      <Row>
                          <Col className="text-center py-3">
                              <div className="footer-links d-flex justify-content-center flex-wrap">
                                  <a href="https://www.linkedin.com/company/102738501/" className="text-dark mx-2 mb-2 d-flex align-items-center">
                                      <span className="me-1">LinkedIn</span> <FaLinkedinIn size={14} />
                                  </a>
                                  <a href="https://huggingface.co/pokkoa" className="text-dark mx-2 mb-2 d-flex align-items-center">
                                      <span className="me-1">🤗 Hugging Face</span>
                                  </a>
                                  <a href="https://www.facebook.com/ai.pokkoa" className="text-dark mx-2 mb-2 d-flex align-items-center">
                                      <span className="me-1">Facebook</span> <FaFacebookF size={14} />
                                  </a>
                                  <a href="https://t.me/pokkoa_bot" className="text-dark mx-2 mb-2 d-flex align-items-center">
                                      <span className="me-1">Telegram</span> <FaTelegramPlane size={14} />
                                  </a>
                                  <a href="https://solscan.io/token/8uM6vA6ajxxgdqUYNM5xYJtfbL1XmDgU5YDvxZg5LL36" className="text-dark mx-2 mb-2">
                                      Pokkoa Coin
                                  </a>
                                  <a href="https://opensea.io/assets/matic/0xca8a287748c3af7a23459ac16468ae93dc251ebb/1" className="text-dark mx-2 mb-2">
                                      NFTs
                                  </a>
                                  <a href="https://character.ai/character/QpMOQWQi" className="text-dark mx-2 mb-2">
                                      Character.ai
                                  </a>
                                  <a href="https://pokkoa.gumroad.com" className="text-dark mx-2 mb-2">
                                      Gumroad
                                  </a>
                                  <a href="mailto:contact@pokkoa.cc" className="text-dark mx-2 mb-2">
                                      Contact Us
                                  </a>
                              </div>
                          </Col>
                      </Row>
                  </Container>
              </footer>
          </Container>
      </Router>
  );
}

export default App;
